import React from "react";
import { Link } from "react-router-dom";
import useActiveEmergency from "../hooks/useActiveEmergency";
import { useClassroomMode } from "./classroomMode";
import "../teacher/Emergency.css";

// App-wide banner shown to everyone in the school while an emergency is active.
// Orange "DRILL" vs pulsing-red "EMERGENCY" so the kind reads at a glance. In
// Classroom Mode the accountability screen is blocked, so it's a non-clickable
// notice (awareness only — staff account for students on their own device).
export default function EmergencyBanner() {
  const { emergency } = useActiveEmergency();
  const { classroomMode } = useClassroomMode();
  if (!emergency) return null;
  const isDrill = emergency.isDrill === true;
  const cls = `emergency-banner ${isDrill ? "is-drill" : ""}`;

  if (classroomMode) {
    return (
      <div className={cls} style={{ cursor: "default" }}>
        {isDrill ? "🟦 DRILL ACTIVE" : "🚨 EMERGENCY ACTIVE"}
      </div>
    );
  }
  return (
    <Link to="/emergency" className={cls}>
      {isDrill
        ? "🟦 DRILL ACTIVE — tap to account for students"
        : "🚨 EMERGENCY ACTIVE — tap to account for students"}
    </Link>
  );
}
